// extracted by mini-css-extract-plugin
module.exports = {"sp-only":"sp-only__2arqD","non-sp-only":"non-sp-only__1zDDF"};